<template>
  <client-only>
    <Teleport to="#floating-actions-container">
      <div class="floating-actions-slot">
        <transition name="fade">
          <div
            v-if="show"
            class="floating-actions fixed bottom-0 left-0 right-0 py-4 px-5 flex flex-col md:flex-row gap-2 bg-white z-20 md:bg-transparent md:w-max md:bottom-6 md-right-16 border-t border-t-accent md:border-t-0"
          >
          <div class="flex gap-2 w-full">
            <SharedFavoriteCarButton v-if="carDetail?.documentId" :car-id="carDetail?.documentId" :car-detail="carDetail" size="medium" class="!hidden md:!block" />
            <SharedButton
              variant="primary"
              :label="t('components.carDetail.actionButtons.bookViewing')"
              @click="bookViewing"
              class="w-full"
              labelClass="md:w-max"
              v-if="['Verkauft', 'Vorverkauft', 'Gesperrt', 'Überprüfen', 'Lagernd'].includes(carDetail?.vehicle_status || '')"
            >
              <template #icon>
                <svg class="text-white mr-2" xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                  <path
                    d="M19.272 6.156L17.904 2.051C17.7056 1.45348 17.3238 0.9337 16.8131 0.565508C16.3024 0.197316 15.6886 -0.000558206 15.059 1.18278e-06H5.941C5.31139 -0.000558206 4.69761 0.197316 4.18688 0.565508C3.67615 0.9337 3.29445 1.45348 3.096 2.051L1.728 6.156C1.36461 6.30848 1.05428 6.56476 0.835845 6.89277C0.617412 7.22077 0.500589 7.60592 0.5 8V13C0.5 13.753 0.923 14.402 1.539 14.743C1.526 14.809 1.5 14.869 1.5 14.938V17C1.5 17.2652 1.60536 17.5196 1.79289 17.7071C1.98043 17.8946 2.23478 18 2.5 18H3.5C3.76522 18 4.01957 17.8946 4.20711 17.7071C4.39464 17.5196 4.5 17.2652 4.5 17V15H16.5V17C16.5 17.2652 16.6054 17.5196 16.7929 17.7071C16.9804 17.8946 17.2348 18 17.5 18H18.5C18.7652 18 19.0196 17.8946 19.2071 17.7071C19.3946 17.5196 19.5 17.2652 19.5 17V14.938C19.5 14.869 19.474 14.808 19.461 14.743C19.7744 14.5721 20.0362 14.3202 20.2189 14.0136C20.4017 13.707 20.4988 13.357 20.5 13V8C20.5 7.171 19.992 6.459 19.272 6.156ZM2.5 13V8H18.5L18.502 13H2.5ZM5.941 2H15.058C15.489 2 15.871 2.274 16.007 2.684L17.113 6H3.887L4.992 2.684C5.05835 2.4848 5.18572 2.31153 5.35605 2.18876C5.52638 2.06599 5.73104 1.99995 5.941 2Z"
                    fill="currentColor"
                  />
                  <path d="M5 12C5.82843 12 6.5 11.3284 6.5 10.5C6.5 9.67157 5.82843 9 5 9C4.17157 9 3.5 9.67157 3.5 10.5C3.5 11.3284 4.17157 12 5 12Z" fill="currentColor" />
                  <path
                    d="M16 12C16.8284 12 17.5 11.3284 17.5 10.5C17.5 9.67157 16.8284 9 16 9C15.1716 9 14.5 9.67157 14.5 10.5C14.5 11.3284 15.1716 12 16 12Z"
                    fill="currentColor"
                  />
                </svg>
              </template>
            </SharedButton>
            <SharedFavoriteCarButton v-else-if="carDetail?.documentId" :car-id="carDetail?.documentId" :car-detail="carDetail" size="medium" class="!block md:!hidden" />

            <!-- <SharedButton
            variant="secondary"
            :label="t('components.carDetail.actionButtons.track')"
            @click="trackCar"
            class="w-full lg:col-span-2"
            v-else-if="['Online', 'Böse'].includes(carDetail?.vehicle_status || '')"
          >
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path
                  d="M10.5 15L11.5 13V7.858C13.221 7.411 14.5 5.858 14.5 4C14.5 1.794 12.706 0 10.5 0C8.294 0 6.5 1.794 6.5 4C6.5 5.858 7.779 7.411 9.5 7.858V13L10.5 15ZM8.5 4C8.5 2.897 9.397 2 10.5 2C11.603 2 12.5 2.897 12.5 4C12.5 5.103 11.603 6 10.5 6C9.397 6 8.5 5.103 8.5 4Z"
                  fill="#37B5AA"
                />
                <path
                  d="M14.767 8.56301L14.234 10.491C16.825 11.207 18.5 12.584 18.5 14C18.5 15.892 15.215 18 10.5 18C5.785 18 2.5 15.892 2.5 14C2.5 12.584 4.175 11.207 6.767 10.49L6.234 8.56201C2.697 9.54001 0.5 11.623 0.5 14C0.5 17.364 4.893 20 10.5 20C16.107 20 20.5 17.364 20.5 14C20.5 11.623 18.303 9.54001 14.767 8.56301Z"
                  fill="#37B5AA"
                />
              </svg>
            </template>
          </SharedButton> -->

            <SharedIconButton variant="accent" to="tel:+43311280100" class="!block md:!hidden">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path
                  d="M14.7071 10.293C14.6143 10.2 14.5041 10.1263 14.3828 10.076C14.2615 10.0257 14.1314 9.99976 14.0001 9.99976C13.8688 9.99976 13.7387 10.0257 13.6174 10.076C13.4961 10.1263 13.3859 10.2 13.2931 10.293L11.6991 11.887C10.9601 11.667 9.58109 11.167 8.70709 10.293C7.83309 9.41896 7.33309 8.03996 7.11309 7.30096L8.70709 5.70696C8.80004 5.61417 8.87377 5.50397 8.92408 5.38265C8.97439 5.26134 9.00029 5.13129 9.00029 4.99996C9.00029 4.86862 8.97439 4.73858 8.92408 4.61726C8.87377 4.49595 8.80004 4.38575 8.70709 4.29296L4.70709 0.292957C4.6143 0.200011 4.5041 0.126273 4.38278 0.0759627C4.26147 0.0256519 4.13142 -0.000244141 4.00009 -0.000244141C3.86876 -0.000244141 3.73871 0.0256519 3.6174 0.0759627C3.49608 0.126273 3.38588 0.200011 3.29309 0.292957L0.58109 3.00496C0.20109 3.38496 -0.0129104 3.90696 -0.00491041 4.43996C0.0180896 5.86396 0.39509 10.81 4.29309 14.708C8.19109 18.606 13.1371 18.982 14.5621 19.006H14.5901C15.1181 19.006 15.6171 18.798 15.9951 18.42L18.7071 15.708C18.8 15.6152 18.8738 15.505 18.9241 15.3837C18.9744 15.2623 19.0003 15.1323 19.0003 15.001C19.0003 14.8696 18.9744 14.7396 18.9241 14.6183C18.8738 14.4969 18.8 14.3867 18.7071 14.294L14.7071 10.293ZM14.5801 17.005C13.3321 16.984 9.06209 16.649 5.70709 13.293C2.34109 9.92696 2.01509 5.64196 1.99509 4.41896L4.00009 2.41396L6.58609 4.99996L5.29309 6.29296C5.17555 6.41041 5.08913 6.55529 5.04164 6.71453C4.99415 6.87376 4.98709 7.04231 5.02109 7.20496C5.04509 7.31996 5.63209 10.047 7.29209 11.707C8.95209 13.367 11.6791 13.954 11.7941 13.978C11.9566 14.0129 12.1254 14.0064 12.2847 13.9591C12.4441 13.9117 12.589 13.825 12.7061 13.707L14.0001 12.414L16.5861 15L14.5801 17.005Z"
                  fill="currentColor"
                />
              </svg>
            </SharedIconButton>
          </div>

          <div class="flex gap-2 w-full">
            <TooltipProvider>
              <TooltipRoot :open="isTooltipOpen">
                <TooltipTrigger asChild>
                  <SharedButton variant="secondary" :label="tradeInButtonLabel" @click="onTradeInClick" class="w-full lg:col-span-1 !px-2 md:!px-4" labelClass="md:w-max">
                    <template #icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-[#37B5AA]">
                        <path d="M18.9 8.60001H15.1V8.70001H18.9V8.60001Z" fill="currentColor" stroke="currentColor" stroke-width="0.1" />
                        <path
                          d="M22 6.70001H20.3L18.9 2.60001C18.7 2.00001 18.1 1.60001 17.5 1.60001H6.49998C5.79998 1.60001 5.19998 2.00001 4.99998 2.60001L3.59998 6.70001H1.79998C1.69998 6.70001 1.59998 6.80001 1.59998 7.00001V7.40001C1.59998 7.60001 1.69998 7.70001 1.89998 7.70001H2.99998V7.80001V8.60001V8.70001V16.6C2.99998 17.1 3.49998 17.6 3.99998 17.6H4.99998C5.49998 17.6 5.99998 17.1 5.99998 16.6V15.6H11V13.6H4.89998V8.70001V8.60001H15.1H18.9V8.70001V12.9L20.9 14.9V8.70001V8.60001V7.70001H22C22.2 7.70001 22.3 7.60001 22.3 7.40001V7.00001C22.3 6.80001 22.1 6.70001 22 6.70001ZM5.69998 6.70001L6.79998 3.60001H17.1L18.2 6.70001H5.69998Z"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width="0.1"
                        />
                        <path d="M15.1 8.60001H4.90002V8.70001H15.1V8.60001Z" fill="currentColor" stroke="currentColor" stroke-width="0.1" />
                        <path
                          d="M21.815 17.965L17.635 13.785C17.445 13.595 17.2075 13.5 16.97 13.5H13.55C13.0275 13.5 12.6 13.9275 12.6 14.45V17.87C12.6 18.1075 12.695 18.345 12.885 18.535L17.065 22.715C17.445 23.095 18.0625 23.095 18.395 22.715L21.815 19.295C22.195 18.9625 22.195 18.345 21.815 17.965ZM14.7375 16.35C14.3575 16.35 14.025 16.0175 14.025 15.6375C14.025 15.2575 14.3575 14.925 14.7375 14.925C15.1175 14.925 15.45 15.2575 15.45 15.6375C15.45 16.0175 15.1175 16.35 14.7375 16.35Z"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width="0.1"
                        />
                        <path
                          d="M17.1 11.5H6.3C6.1 11.5 6 11.4 6 11.2V10.3C6 10.1 6.1 10 6.3 10H17.1C17.3 10 17.4 10.1 17.4 10.3V11.2C17.4 11.3 17.3 11.5 17.1 11.5Z"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width="0.1"
                        />
                      </svg>
                    </template>
                  </SharedButton>
                </TooltipTrigger>
                <TooltipPortal>
                  <TooltipContent class="max-w-[218px] bg-white text-small-semibold px-2 py-3 rounded-[6px] border border-neutral-light flex flex-row gap-2">
                    <div>
                      {{ t('components.carDetail.actionButtons.openTradeInFormInfo') }}
                    </div>
                    <svg
                      class="hover:cursor-pointer block !size-2 min-w-2 mt-1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                      @click="closeTradeInTooltip"
                    >
                      <path
                        d="M6.59933 0L3.77067 2.828L0.942666 0L0 0.942667L2.828 3.77067L0 6.59867L0.942666 7.54133L3.77067 4.71333L6.59933 7.54133L7.542 6.59867L4.714 3.77067L7.542 0.942667L6.59933 0Z"
                        fill="#1A847B"
                      />
                    </svg>
                    <TooltipArrow class="fill-white stroke-neutral-light" :width="16" :height="8" />
                  </TooltipContent>
                </TooltipPortal>
              </TooltipRoot>
            </TooltipProvider>

            <SharedButton v-if="showPriceWatchButton" variant="secondary" :label="priceWatcherButtonLabel" @click="onPriceWatcherClick" class="w-full !px-2 md:!px-4 lg:col-span-1" labelClass="md:w-max">
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M17.3369 1.81L21.9439 5.655L20.6639 7.19L16.0539 3.347L17.3369 1.81ZM6.66288 1.81L7.94489 3.346L3.33688 7.19L2.05688 5.654L6.66288 1.81ZM11.9999 4C7.02988 4 2.99988 8.03 2.99988 13C2.99988 17.97 7.02988 22 11.9999 22C16.9699 22 20.9999 17.97 20.9999 13C20.9999 8.03 16.9699 4 11.9999 4ZM11.9999 20C8.13988 20 4.99988 16.86 4.99988 13C4.99988 9.14 8.13988 6 11.9999 6C15.8599 6 18.9999 9.14 18.9999 13C18.9999 16.86 15.8599 20 11.9999 20ZM12.9999 9H10.9999V12H7.99988V14H10.9999V17H12.9999V14H15.9999V12H12.9999V9Z"
                    fill="#37B5AA"
                    stroke="#37B5AA"
                    stroke-width="0.1"
                  />
                </svg>
              </template>
            </SharedButton>
          </div>
          </div>
        </transition>
      </div>
    </Teleport>
  </client-only>
</template>

<script lang="ts" setup>
  import type { GraphQLCarDetail } from '~/types/graphql';
  import type { Toast } from '~/components/GlobalToast/index.vue';
  import type { AuwsObject } from '~/types/types';
  import { useStorage } from '@vueuse/core';
  import { TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from 'reka-ui';

  const { t } = useI18n();

  const eventBus = useEventBus();
  const carDetail = inject<GraphQLCarDetail>('carDetail');

  const favoriteCars = useStorage<string[]>('favoriteCars', []);

  interface EventData {
    event:
      | 'print'
      | 'share_in_facebook'
      | 'send_in_email'
      | 'copy_link'
      | 'book_viewing'
      | 'share_to_whatsapp'
      | 'call_on_whatsapp'
      | 'open_financing_modal'
      | 'goto_contact_form'
      | 'open_trade_in_form'
      | 'open_price_watcher_modal';
    page_location: string;
    page_title: string;
    vehicle_id: string;
    make?: string;
    model?: string;
    price?: number;
    fuel_type?: string;
    manufactured_at?: string;
  }

  const { push } = useDataLayer();

  const sendEvent = (event_type: EventData['event']) => {
    const eventData: EventData = {
      event: event_type,
      page_location: window.location.href,
      page_title: window.document.title,
      vehicle_id: carDetail ? carDetail.internal_vehicle_no?.toString() || '' : '',
    };
    if (carDetail) {
      eventData.make = carDetail.make?.name;
      eventData.model = carDetail.model;
      eventData.manufactured_at = carDetail.year_of_manufacture?.toString() || '';
      eventData.price = carDetail.asking_price || undefined;
      eventData.fuel_type = carDetail.fuel_type || undefined;
    }
    push(eventData);
  };

  const addToFavorites = () => {
    if (favoriteCars.value.includes(carDetail!.documentId)) {
    } else {
      favoriteCars.value.push(carDetail!.documentId);
    }
    const toast: Toast = {
      show: true,
      message: t('components.carDetail.actionButtons.addedToFavorites'),
      type: 'foreground',
    };
    eventBus.emit('add-global-toast', toast);
  };

  const bookViewing = () => {
    eventBus.emit('open-book-test-drive-modal', {
      carDetail: carDetail,
    });
  };

  const trackCar = () => {
    eventBus.emit('track-car', carDetail!.documentId);
    alert('Car tracked');
  };

  const { y } = useWindowScroll();
  const { width } = useWindowSize();

  const show = computed(() => {
    if (!carDetail) return false;

    if (width.value < 768) return true;

    if (width.value > 768) return y.value > 100;
  });

  const tradeInButtonLabel = computed(() => {
    if (width.value < 900) return t('components.carDetail.actionButtons.openTradeInForm');
    return t('components.carDetail.actionButtons.openTradeInFormLong');
  });

  const priceWatcherButtonLabel = computed(() => {
    if (width.value < 900) return t('components.carDetail.actionButtons.openPriceWatcherModal');
    return t('components.carDetail.actionButtons.openPriceWatcherModalLong');
  });

  const onTradeInClick = () => {
    sendEvent('open_trade_in_form');

    eventBus.emit('open-trade-in-form', {
      carDetail: carDetail,
    });
  };

  const onPriceWatcherClick = () => {
    sendEvent('open_price_watcher_modal');

    eventBus.emit('open-price-watcher-modal', {
      carDetail: carDetail,
    });
  };

  const tradeInTooltipInteracted = useStorage('tradeInTooltipInteracted', false);
  const isTooltipOpen = ref(!tradeInTooltipInteracted.value);

  const closeTradeInTooltip = () => {
    isTooltipOpen.value = false;
    tradeInTooltipInteracted.value = true;
  };

  const priceAlertEnabled = useExternalWatcher<boolean>(
    () => (window as unknown as { auws?: AuwsObject }).auws?.settings?.flowAvailability?.price_alert ?? false
  );
  const showPriceWatchButton = ref(false);

  watch(priceAlertEnabled, enabled => {
    showPriceWatchButton.value = !!enabled;
  });
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
